import { Grid, ContactShadows, useAnimations, useGLTF } from '@react-three/drei'
import { useEffect } from 'react'
import { useControls } from 'leva'

export default function DCW()
{
    const dude = useGLTF('./dcw_character/glb/dcw.glb')
    const animations = useAnimations(dude.animations, dude.scene)


    // const { animationName } = useControls({
    //     animationName: { options: animations.names } 
    // })    

    // useEffect(() =>
    // {
    //     const action = animations.actions[animationName]
    //     action
    //     .reset()
    //     .fadeIn(1.5)
    //     .play([3])

    //     return () =>
    //     {
    //         action.fadeOut(1.5)
    //     }

    // }, [animationName])
    useEffect(() => {
        const action = animations.actions.dance_sway
        action.play()

    }, [])
    

    return <primitive
        object={ dude.scene }
        scale= { 2 }
        position = { [ 0 , - 1, 0.5] }
    />
}